import { Reveal } from "../landing/Reveal";

const BITES = [
  { emoji: "🍔", name: "FoodBite", desc: "Meals from student chefs, ordered in a tap", grad: "from-[#F97316] to-[#22C55E]", href: "#foodbite" },
  { emoji: "📚", name: "LearnBite", desc: "Gamified skills with streaks and badges", grad: "from-[#7C3AED] to-[#A78BFA]", href: "#learnbite" },
  { emoji: "💼", name: "CareerBite", desc: "One-click jobs, internships and referrals", grad: "from-[#06B6D4] to-[#7C3AED]", href: "#careerbite" },
  { emoji: "🛍️", name: "ShopBite", desc: "Reel-to-checkout campus shopping", grad: "from-[#22C55E] to-[#F97316]", href: "#shopbite" },
  { emoji: "✈️", name: "TravelBite", desc: "Student trips and educational tours", grad: "from-[#06B6D4] to-[#4ADE80]", href: "#travelbite" },
  { emoji: "🌱", name: "GreenBite", desc: "Meals donated, farmers supported", grad: "from-[#06B6D4] to-[#22C55E]", href: "#greenbite" },
  { emoji: "🧒", name: "KidsBite", desc: "Safe learning bites for younger siblings", grad: "from-[#A78BFA] to-[#F97316]", href: "#explore" },
  { emoji: "💬", name: "CommunicationBite", desc: "Communities, clubs and campus chat", grad: "from-[#7C3AED] to-[#06B6D4]", href: "#communities" },
];

export const ExploreBites = () => (
  <section id="explore" data-testid="explore-section" className="relative py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#06B6D4]">Explore</p>
        <h2 className="mt-3 max-w-xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
          Every Bite of campus life.
        </h2>
      </Reveal>

      <div className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {BITES.map((b, i) => (
          <Reveal key={b.name} delay={0.05 * i} className="h-full">
            <a
              href={b.href}
              data-testid={`bite-card-${b.name.toLowerCase()}`}
              className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04] p-6 backdrop-blur-xl transition-all duration-300 hover:-translate-y-1.5 hover:border-white/25"
            >
              <div
                aria-hidden="true"
                className={`absolute -right-8 -top-8 h-28 w-28 rounded-full bg-gradient-to-br ${b.grad} opacity-20 blur-2xl transition-opacity group-hover:opacity-40`}
              />
              <span className="text-4xl transition-transform duration-300 group-hover:-rotate-12 group-hover:scale-125">
                {b.emoji}
              </span>
              <h3 className="mt-4 font-display text-lg font-bold text-white">{b.name}</h3>
              <p className="mt-1.5 text-xs leading-relaxed text-slate-400 sm:text-sm">{b.desc}</p>
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
